import { module as Module } from 'modujs'
import { body } from '../utils/environment'

export default class extends Module {
  constructor(m) {
    super(m)
  }

  init() {
    this.data = {
      slug: this.el.dataset.slug,
    }

    this.checkClassNames()
  }

  checkClassNames() {
    if (body.classList.contains(`term-${this.data.slug}`)) {
      this.el.classList.add('-is-active')
    }
  }

  update() {
    this.checkClassNames()
  }

  destroy() {
    this.el.classList.remove('-is-active')
  }
}
